import { ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs));
}

export function toDate(d: string): Date {
    let date = new Date();
    let splitted = d.split("/");
    date.setDate(parseInt(splitted[0]));
    date.setMonth(parseInt(splitted[1]) - 1);
    date.setFullYear(parseInt(splitted[2]));
    return date;
}

export function fullDate(d: Date) {
    return d.getDate() + "/" + (d.getMonth() + 1) + "/" + d.getFullYear();
}

export function createSlug(text: string): string {
    const slug = text
        .toLowerCase()
        .replace(/[^\w\s-]/g, "")
        .trim()
        .replace(/\s+/g, "-")
        .replace(/--+/g, "-");

    return slug;
}

export function replaceFirstOccurrence(originalString: string, targetSubstring: string, replacement: string): string {
    const index = originalString.indexOf(targetSubstring);
    if (index !== -1) {
        return originalString.substring(0, index) + replacement + originalString.substring(index + targetSubstring.length);
    }
    return originalString;
}

export function formatToEuro(input: number): string {
    const formatting_options = {
        style: "currency",
        currency: "EUR",
        minimumFractionDigits: 2
    };
    return input.toLocaleString("en-US", formatting_options);
}
